import {useEffect, useState} from "react";
import {Link, useSearchParams} from "react-router-dom";
import search_api from "../api/protected/search"

import search from "../assets/search.png";
import team from "../assets/team.png"
import organisation from "../assets/organisation.png"
import survey from "../assets/survey.png"
import person from "../assets/person.png"

const SearchPage = () => {
    const [parameters, setParameters] = useSearchParams();

    const [limit, setLimit] = useState(10)
    const [searchTerm, setSearchTerm] = useState('');

    const [organisations, setOrganisations] = useState([]);
    const [teams, setTeams] = useState([]);
    const [surveys, setSurveys] = useState([]);
    const [teamPeople, setTeamPeople] = useState([]);


    useEffect(() => {
        let term = parameters.get("term")
        if (!term) return;
        setSearchTerm(term)
    }, [parameters.get("term")]);

    useEffect(() => {
        setParameters({"term": searchTerm})
        Search()
    }, [searchTerm])

    const Search = () => {
        if (!searchTerm) return;
        let response = search_api.globalSearch(searchTerm, limit);
        response.then(
            response => {
                setOrganisations(response.data.organisations);
                setTeams(response.data.teams);
                setSurveys(response.data.surveys);
                setTeamPeople(response.data.team_people);
            }
        )
    }

    return (
        <div className="organisations-page-background-container">
            <div className="organisations-page-container">
                <div className="organisations-page-header">
                    <div className="organisations-page-title">Search</div>
                    <div className="organisations-page-search-container">
                        <input type="text" placeholder="Organisation Search" value={searchTerm}
                               onChange={(ev) => setSearchTerm(ev.target.value)}/>
                        <img src={search} alt="search icon" className="link"/>
                    </div>
                </div>
                <div className="search-page-results-container">
                    {organisations && organisations.map((element, idx) => {
                        return (
                            <div className="search-page-result" key={idx}>
                                <div className="result-image-identifier organisation">
                                    <img src={organisation} alt="Organisation"/>
                                </div>
                                <Link to={"/organisations/" + element.id} className="link organisation">
                                    {element.name}
                                </Link>
                            </div>
                        )
                    })}
                    {teams && teams.map((element, idx) => {
                        return (
                            <div className="search-page-result" key={idx}>
                                <div className="result-image-identifier team">
                                    <img src={team} alt="Team" />
                                </div>
                                <Link to={"/organisations/" + element.organisation.id} className="link organisation">
                                    {element.organisation.name}
                                </Link>
                                <div className="search-page-result-separator">
                                    >
                                </div>
                                <Link to={"/teams/" + element.id} className="link organisation">
                                    {element.name}
                                </Link>
                            </div>
                        )
                    })}
                    {surveys && surveys.map((element, idx) => {
                        return (
                            <div className="search-page-result" key={idx}>
                                <div className="result-image-identifier survey">
                                    <img src={survey} alt="Survey"/>
                                </div>
                                <Link to={"/organisations/" + element.organisation.id} className="link organisation">
                                    {element.organisation.name}
                                </Link>
                                <div className="search-page-result-separator">
                                    >
                                </div>
                                <Link to={"/teams/" + element.team.id} className="link organisation">
                                    {element.team.name}
                                </Link>
                                <div className="search-page-result-separator">
                                    >
                                </div>
                                <Link to={"/teams/" + element.team.id} className="link organisation">
                                    {element.name}
                                </Link>
                            </div>
                        )
                    })}
                    {teamPeople && teamPeople.map((element, idx) => {
                        return (
                            <div className="search-page-result" key={idx}>
                                <div className="result-image-identifier person">
                                    <img src={person} alt="Person"/>
                                </div>
                                <Link to={"/organisations/" + element.organisation.id} className="link organisation">
                                    {element.organisation.name}
                                </Link>
                                <div className="search-page-result-separator">
                                    >
                                </div>
                                <Link to={"/teams/" + element.team.id} className="link organisation">
                                    {element.team.name}
                                </Link>
                                <div className="search-page-result-separator">
                                    >
                                </div>
                                <Link to={"/teams/" + element.team.id} className="link organisation">
                                    {element.name}
                                </Link>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}

export default SearchPage
